import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { FontIcon, IRectangle, List, Spinner, SpinnerSize, TooltipHost } from 'office-ui-fabric-react';
import { getTheme, ITheme, mergeStyleSets, registerIcons } from 'office-ui-fabric-react/lib/Styling';
import { uPrinceTheme } from '../../../theme';
import UprinceLogger from '../Logger/logger';
import { getFileType } from './getFileType';
import { SvgIcons } from '../svgIcons/svgIcons';
import DocumentPreviewModal from './documentPreviewModal';

registerIcons(SvgIcons);

const theme: ITheme = getTheme();
const { palette, fonts } = theme;
const ROWS_PER_PAGE = 3;
const MAX_ROW_HEIGHT = 250;
const classNames = mergeStyleSets({
  listGridExample: {
    overflow: 'hidden',
    fontSize: 0,
    position: 'relative',
  },
  listGridExampleTileAnimated: {
    textAlign: 'center',
    outline: 'none',
    position: 'relative',
    // marginLeft:1,
    float: 'left',
    // background: palette.neutralLighter,
    transition: 'transform 0.8s ease-in-out',
    transform: 'rotateY(180deg)',

    selectors: {
      'focus:after': {
        content: '',
        position: 'absolute',
        left: 2,
        right: 2,
        top: 2,
        bottom: 2,
        boxSizing: 'border-box',
        border: `1px solid ${palette.white}`,
      },
      // ':hover': {
      //     transition: 'transform 0.8s ease-in-out',
      //     transform: 'rotateY(180deg)',
      // },
    },
  },
  listGridExampleTile: {
    textAlign: 'center',
    outline: 'none',
    position: 'relative',
    // marginLeft:1,
    float: 'left',
    // background: palette.neutralLighter,
    transition: 'transform 0.8s ease-in-out',
    transform: 'rotateY(0deg)',

    selectors: {
      'focus:after': {
        content: '',
        position: 'absolute',
        left: 2,
        right: 2,
        top: 2,
        bottom: 2,
        boxSizing: 'border-box',
        border: `1px solid ${palette.white}`,
      },
      // ':hover': {
      //     transition: 'transform 0.8s ease-in-out',
      //     transform: 'rotateY(180deg)',
      // },
    },
  },
  listGridExampleSizer: {
    paddingBottom: '100%',
  },
  listGridExamplePadder: {
    position: 'absolute',
    left: 2,
    top: 2,
    right: 2,
    bottom: 2,
  },
  fileNameStyle: {
    background: 'rgba(0, 0, 0, 0.3)',
    color: '#FFFFFF',
    position: 'absolute',
    padding: 10,
    bottom: 0,
    left: 0,
    width: '100%',
    fontSize: fonts.small.fontSize,
    boxSizing: 'border-box',
  },
  listGridExampleLabel: {
    color: uPrinceTheme.palette.themePrimary,
    position: 'absolute',
    padding: 10,
    paddingRight: 5,
    bottom: '68%',
    textAlign: 'end',
    left: 0,
    width: '100%',
    fontSize: fonts.small.fontSize,
    boxSizing: 'border-box',
  },
  listGridExampleLabelAnimated: {
    color: uPrinceTheme.palette.themePrimary,
    position: 'absolute',
    padding: 10,
    paddingRight: 5,
    bottom: '30%',
    textAlign: 'end',
    left: 0,
    width: '100%',
    fontSize: fonts.small.fontSize,
    boxSizing: 'border-box',
  },
  listGridExampleImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  listGridExampleImageAnimated: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    filter: 'blur(4px)',
    height: '100%',

  },
});

export interface UploadedImage {
  id: string | null;
  image: string | null;
}

const ImagePreview = (props: {
  uploadedImages: any,
  handleImageDelete: (id: string) => void,
  transition: boolean,
  disable?: boolean
  isDelete?: boolean
}) => {
  const [isOpenImageModal, setIsOpenImageModal]: any = useState(false);
  const [selectedImage, setSelectedImage]: any = useState(null);
  const [selectedType, setSelectedType]: any = useState('');
  const [transition, setTransition]: any = useState(false);
  const [uploadedImages, setUploadedImages]: any = useState([]);
  useEffect(() => {
    setTransition(props.transition);
  }, [props.transition]);
  useEffect(() => {
    setUploadedImages(props.uploadedImages);
  }, [props.uploadedImages]);
  UprinceLogger.log('uploadedImages ImageGrid', props.uploadedImages);
  const { t } = useTranslation();
  const columnCount = React.useRef(0);
  const rowHeight = React.useRef(0);


  const openImageModal = (image: any, type: string) => {
    setSelectedImage(image);
    setSelectedType(type);
    setIsOpenImageModal(true);
  };


  const renderPreview = (item?: { thumbnail: string, id: string, extension: string } | undefined) => {
    let fileType = getFileType(item?.thumbnail, item?.extension);
    if (fileType && fileType.type === 'image') {
      return (
        <div className={`oneImage ${JSON.stringify(item?.id)}`}>
          <img alt={item?.id} onClick={(event) => {
            event.preventDefault();
            openImageModal(item?.thumbnail, 'image');
            //window.open(item?.thumbnail);
          }} src={item?.thumbnail} className={classNames.listGridExampleImage}/>
          <span className={classNames.listGridExampleLabel}>&nbsp;
            {(!props.disable) ? (props.isDelete && item?.id != null) ? <span onClick={() => {
              props.handleImageDelete(item?.id);
            }} style={{ cursor: 'pointer' }}><FontIcon iconName="Delete"
                                                       className="removeIcon"/></span> : false : false}
              </span>
        </div>
      );
    } else {
      return (
        <div className={'icon'}>
          <img alt={item?.id} onClick={(event) => {
            event.preventDefault();
            if (fileType.type === 'excel' || fileType.type === 'powerPoint' || fileType.type === 'document') {
              window.open(item?.thumbnail, 'file');
            } else if (fileType.type === 'pdf') {
              let res = item?.thumbnail.split('.').pop();
              if (res === 'pdf' || res === 'PDF') {
                window.open(item?.thumbnail, 'file');
              } else {
                openImageModal(item?.thumbnail, 'file');
              }
            } else {
              openImageModal(item?.thumbnail, 'file');
            }
          }} src={fileType.image} className={classNames.listGridExampleImage}/>
          <span className={classNames.listGridExampleLabel}>&nbsp;
            {(!props.disable) ? (props.isDelete && item?.id != null) ? <span onClick={() => {
              props.handleImageDelete(item?.id);
            }} style={{ cursor: 'pointer' }}><FontIcon iconName="Delete"
                                                       className="removeIcon"/></span> : false : false}
              </span>
        </div>
      );
    }

  };

  const getItemCountForPage = React.useCallback((itemIndex?: number | undefined, visibleRect?: IRectangle | undefined) => {
    if (itemIndex === 0 && visibleRect) {
      columnCount.current = Math.ceil(visibleRect.width / MAX_ROW_HEIGHT);
      rowHeight.current = Math.floor(visibleRect.width / columnCount.current);
    }
    return columnCount.current * ROWS_PER_PAGE;
  }, []);

  const onRenderCell = React.useCallback(
    (item?: { thumbnail: string, id: string, extension: string } | undefined, index?: number | undefined, isScrolling?: boolean | undefined) => {
      return (
        <div
          className={classNames.listGridExampleTile}
          data-is-focusable
          style={{
            width: '20%',
          }}
        >
          <div className={classNames.listGridExampleSizer}>
            <div className={classNames.listGridExamplePadder}>
              {renderPreview(item)}
            </div>
          </div>
          {item?.thumbnail !== '/465d79325d28da8ce03933e8285eca4b.jpg' && <TooltipHost
            content={getFileName(item?.thumbnail!!)}
            id={'onRenderCell'}
          >
            <span className={classNames.fileNameStyle}>{getShortFileName(item?.thumbnail!!)}</span>
          </TooltipHost>}
        </div>
      );
    },
    [columnCount.current],
  );

  const onRenderCellAnimated = React.useCallback(
    (item?: { thumbnail: string, id: string, isLast: boolean, extension: string } | undefined, index?: number | undefined, isScrolling?: boolean | undefined) => {
      if (item?.isLast) {
        return (
          <div
            className={(item?.isLast) ? classNames.listGridExampleTileAnimated : classNames.listGridExampleTile}
            data-is-focusable
            style={{
              width: 50 / columnCount.current + '%',
            }}
          >
            <div className={classNames.listGridExampleSizer}>
              <div className={classNames.listGridExamplePadder}>

                {/*<img src={dummyimage} className={classNames.listGridExampleImageAnimated}/>*/}
                <span className={classNames.listGridExampleLabelAnimated}>&nbsp;
                  <Spinner size={SpinnerSize.large}/>
              </span>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div
            className={classNames.listGridExampleTile}
            data-is-focusable
            style={{
              width: '20%',
            }}
          >
            <div className={classNames.listGridExampleSizer}>
              <div className={classNames.listGridExamplePadder}>
                {renderPreview(item)}
              </div>
            </div>
            {item?.thumbnail !== '/465d79325d28da8ce03933e8285eca4b.jpg' && <TooltipHost
              content={getFileName(item?.thumbnail!!)}
              id={'onRenderCellAnimated'}
            >
              <span className={classNames.fileNameStyle}>{getShortFileName(item?.thumbnail!!)}</span>
            </TooltipHost>}
          </div>
        );
      }

    },
    [columnCount.current],
  );



  const getFileName = (item: string) => {
    let decoded = decodeURIComponent(item);
    let fileName = decoded.substring(decoded.indexOf('M') + 1);

    return fileName;
  };

  const getShortFileName = (item: string) => {
    let shortFileName = ((getFileName(item)).substring(0, 10)) + '...';

    return shortFileName;
  };

  const getPageHeight = (): number => {
    return rowHeight.current * ROWS_PER_PAGE;
  };

  const getImages = () => {

    if (props.uploadedImages && props.uploadedImages.length > 0) {
      let images = props.uploadedImages.map((item: any) => {
        return { thumbnail: item.image, id: item.id, isLast: item.isLast, extension: item?.extension };
      });
      return images;
    } else {
      return [];
    }

  };
  return (
    <div>
      <FocusZone>
        {transition ? <List
          className={classNames.listGridExample}
          items={getImages()}
          getItemCountForPage={getItemCountForPage}
          // eslint-disable-next-line react/jsx-no-bind
          getPageHeight={getPageHeight}
          renderedWindowsAhead={4}
          onRenderCell={onRenderCellAnimated}
        /> : <List
          className={classNames.listGridExample}
          items={getImages()}
          getItemCountForPage={getItemCountForPage}
          // eslint-disable-next-line react/jsx-no-bind
          getPageHeight={getPageHeight}
          renderedWindowsAhead={4}
          onRenderCell={onRenderCell}
        />}
      </FocusZone>
      <DocumentPreviewModal type={selectedType} openImageModal={() => {
        setIsOpenImageModal(false);
      }} isOpen={isOpenImageModal} image={selectedImage}/>
    </div>
  );

};

export default ImagePreview;
